<template>
  <div class="action-center-unlock-banner brand-gate-card mb-4">
    <div class="action-center-unlock-banner__inner">
      <div class="action-center-unlock-banner__copy">
        <div class="action-center-unlock-banner__title brand-gate-card__title">
          You're seeing {{ previewShown }} of {{ totalActions }} prioritized actions
        </div>
        <p class="action-center-unlock-banner__subtitle brand-gate-card__body">
          Upgrade to Intelligence or Enterprise to unlock your complete action plan — {{ criticalCount }} critical,
          {{ highCount }} high, and {{ quickWinsCount }} quick wins.
        </p>
      </div>
      <v-btn
        variant="flat"
        class="brand-upgrade-cta-btn text-none"
        rounded="pill"
        size="large"
        @click="$router.push('/profile?tab=billing')"
      >
        Upgrade your plan →
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ActionCenterUnlockBanner',
  props: {
    previewShown: {
      type: Number,
      required: true
    },
    totalActions: {
      type: Number,
      required: true
    },
    criticalCount: {
      type: Number,
      default: 0
    },
    highCount: {
      type: Number,
      default: 0
    },
    quickWinsCount: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style scoped>
.action-center-unlock-banner__inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px 24px;
}

.action-center-unlock-banner__copy {
  flex: 1 1 280px;
  min-width: 0;
}

.action-center-unlock-banner__title {
  font-size: 1rem;
  line-height: 1.4;
  letter-spacing: 0.01em;
}

.action-center-unlock-banner__subtitle {
  margin: 6px 0 0;
  font-size: 0.875rem;
  line-height: 1.5;
  font-weight: 400;
}
</style>
